import mixpanel from 'mixpanel-browser';

import { Modals } from '@/constants';
import { store, uiActions, userPreferencesActions } from '@/store';

const TEST_MODE_FLAG = 'testMode';
const ANALYTICS_CONSOLE_LOGS_FLAG = 'analyticsConsoleLogs';
const TRAILER_PREVIEW_DELAY_FLAG = 'trailerPreviewDelay';
const DEFAULT_TRAILER_PREVIEW_DELAY = 750;

const enableToggleTestMode = () => {
  if (window.location.host !== 'app.lumiqlearn.com') {
    window.toggleTestMode = () => {
      const testMode = window.localStorage.getItem(TEST_MODE_FLAG);
      if (testMode) {
        window.localStorage.removeItem(TEST_MODE_FLAG);
      } else {
        window.localStorage.setItem(TEST_MODE_FLAG, 'true');
      }
      console.log('Test Mode On: ', !testMode);
    };
  }
};

export const isTestModeEnabled = () => {
  return (
    window.location.host !== 'app.lumiqlearn.com' &&
    window.localStorage.getItem(TEST_MODE_FLAG) === 'true'
  );
};

const enableToggleAnalyticsConsoleLogs = () => {
  window.toggleAnalyticsConsoleLogs = () => {
    const analyticsConsoleLogs = window.localStorage.getItem(
      ANALYTICS_CONSOLE_LOGS_FLAG,
    );
    if (analyticsConsoleLogs) {
      window.localStorage.removeItem(ANALYTICS_CONSOLE_LOGS_FLAG);
    } else {
      window.localStorage.setItem(ANALYTICS_CONSOLE_LOGS_FLAG, 'true');
    }
    console.log('Analytics Console Logs On: ', !analyticsConsoleLogs);
  };
};

export const isAnalyticsConsoleLogsEnabled = () => {
  return window.localStorage.getItem(ANALYTICS_CONSOLE_LOGS_FLAG) === 'true';
};

const enableSetTrailerPreviewDelay = () => {
  window.setTrailerPreviewDelay = (ms: number) => {
    if (typeof ms === 'number' && ms >= 0) {
      window.localStorage.setItem(TRAILER_PREVIEW_DELAY_FLAG, String(ms));
      console.log(`Trailer Preview Delay set to: ${ms}ms`);
    } else {
      console.log(`Invalid trailer preview delay: ${ms}`);
    }
  };
};

export const getTrailerPreviewDelay = (): number => {
  const stored = window.localStorage.getItem(TRAILER_PREVIEW_DELAY_FLAG);
  return stored ? Number(stored) : DEFAULT_TRAILER_PREVIEW_DELAY;
};

const enableResetMixpanel = () => {
  window.resetMixpanel = () => {
    console.log('Previous distinct id:', mixpanel.get_distinct_id());
    mixpanel.reset();
    console.log('New distinct id:', mixpanel.get_distinct_id());
  };
};

const enableViewDevUtilsState = () => {
  window.viewDevUtilsState = () => {
    console.log({
      testMode: isTestModeEnabled(),
      analyticsConsoleLogs: isAnalyticsConsoleLogsEnabled(),
      trailerPreviewDelay: getTrailerPreviewDelay(),
    });
  };
};

const enableResetUserPreferences = () => {
  window.resetUserPreferences = () => {
    store.dispatch(userPreferencesActions.resetUserPreferences());
    console.log('User preferences have been reset to default values.');
  };
};

const enableProductFeedbackTrigger = () => {
  window.requestProductFeedback = () => {
    store.dispatch(uiActions.setActiveModal({ name: Modals.PRODUCT_FEEDBACK }));
  };
};

export const enableDeveloperConsoleUtils = () => {
  enableToggleTestMode();
  enableToggleAnalyticsConsoleLogs();
  enableSetTrailerPreviewDelay();
  enableResetMixpanel();
  enableViewDevUtilsState();
  enableResetUserPreferences();
  enableProductFeedbackTrigger();
};
